export enum statuses {
  "error" = "error",
  "ready_for_print" = "ready_for_print",
  "label_created" = "label_created",
  "cancelled" = "cancelled",
}
